import type {RendererThis, Tokens} from 'marked';

import {escapeHtml} from '../utils';

// Регулярное выражение и код экстеншена взят из marked-katex-extension
const inlineLatexRegex = /^(\${1,2})(?!\$)((?:\\.|[^\\\n])*?(?:\\.|[^\\\n$]))\1(?=[\s?!.,:？！。，：]|$)/;

export const inlineLatexExtension = {
    name: 'inlinelatex',
    level: 'inline',
    start(src: string) {
        let index;
        let indexSrc = src;

        while (indexSrc) {
            index = indexSrc.indexOf('$');
            if (index === -1) {
                return;
            }
            const found = index === 0 || indexSrc.charAt(index - 1) === ' ';
            if (found) {
                const possibleKatex = indexSrc.substring(index);

                if (possibleKatex.match(inlineLatexRegex)) {
                    return index;
                }
            }

            indexSrc = indexSrc.substring(index + 1).replace(/^\$+/, '');
        }
    },
    tokenizer(src: string) {
        const match = src.match(inlineLatexRegex);

        if (!match) {
            return;
        }

        return {
            type: 'inlinelatex',
            raw: match[0],
            text: match[2]?.trim(),
        };
    },
    renderer(this: RendererThis, token: Tokens.Generic) {
        return `<span data-inline-latex="${escapeHtml(token.text)}"></span>`;
    },
};
